import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import BillPaymentOnlyComponent from './bill-payment-only.component';
import ContentService from '../../services/content.service';

let BillPaymentOnlyModule = angular
  .module('BillPaymentOnly', [
    uiRouter
  ])
  .component('billpaymentonly', BillPaymentOnlyComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('paymentOnly', {
      url: '/payment-only',
      data: {
        authRequired: true
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'billpaymentonly'
        }
      }
    })
  })
  .name;

export default BillPaymentOnlyModule;



// WEBPACK FOOTER //
// ./src/app/pages/bill-payment-only/bill-payment-only.module.js